import React from 'react';

import { Filter } from '~/evifields/src/types/Filter';
import { NumberValue } from '~/evifields/src/types/Value';
import { useFormatNumber } from '~/i18n/hooks/useFormatNumber/useFormatNumber';

import { TextContainer } from '../TextContainer';
import { coerceFormatNumber } from '../utils';

interface Props {
  filter: Filter<NumberValue>;
}

export const NumberValuesPreview = ({ filter }: Props) => {
  const formatNumber = useFormatNumber();
  const { values } = filter;
  const [value1, value2] = values;

  return values.length === 1 ? (
    <TextContainer text={coerceFormatNumber(value1, formatNumber)} />
  ) : (
    <TextContainer.Pair
      delimiter="to"
      texts={[
        coerceFormatNumber(value1, formatNumber),
        coerceFormatNumber(value2, formatNumber),
      ]}
    />
  );
};
